module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon_money-7a05685cbc80dd4502895a1c9d816ac1.svg";